import { mapActions } from 'vuex'

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    owner: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    initials: function () {
      const names = this.user.name.split(' ')
      const res = names
        .map((name) => {
          return name[0]
        })
        .join('')
        .toUpperCase()
      return res
    },
    isOwner: function () {
      return this.user.user_id === (this.owner.id || this.owner.user_id)
    }
  },
  methods: {
    ...mapActions('user', ['getUser'])
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-templates/create-update-competition/create-update-competition-content/permissionRow/permissionRow.js